// declare var google: any;
// It only works as a directive

// export const GoogleDirectionsMapComponent = {
// scope: {},
// bindToController: {
//   item: '='
// },
// controller: GoogleDirectionsMapController,
// controllerAs: 'vm',
// };

export function GoogleDirectionsMapComponent() {
  return {
    scope: {},
    bindToController: {
      item: '=',
      test: '@',
    },
    restrict: 'E',
    transclude: true,
    replace: true,
    template: '<div></div>',
    controller: GoogleDirectionsMapController,
    controllerAs: 'vm',
  };
}

GoogleDirectionsMapController.$inject = ['$element', 'GoogleMapService'];

function GoogleDirectionsMapController($element, GoogleMapService) {
  var vm = this;

  vm.$onInit = function () {
    // console.log(vm.item);
    // Check if latitude and longitude are specified
    //if (angular.isDefined(vm.lat) && angular.isDefined(vm.lng)) {
    // Loads google map script
    setTimeout(function () {
      // console.log(vm.item);
      // Delay x sec to fully load the library
      GoogleMapService.loadGoogleMapScript.then(function () {
        initializeMap(vm.item);
      });
    }, 500);
    //}
  };

  var initializeMap = function (item) {
    var directionsDisplay = new google.maps.DirectionsRenderer();
    var directionsService = new google.maps.DirectionsService();

    var mapOptions = {
      zoom: 14,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
    };

    var map = new google.maps.Map($element[0], mapOptions);

    directionsDisplay.setMap(map);
    calculateAndDisplayRoute(directionsService, directionsDisplay, item);
  };

  function calculateAndDisplayRoute(directionsService, directionsDisplay, item) {
    var origin = {
      lat: parseFloat(item.departure.lat) || 0,
      lng: parseFloat(item.departure.lng) || 0,
    };
    var destination = {
      lat: parseFloat(item.arrival.lat) || 0,
      lng: parseFloat(item.arrival.lng) || 0,
    };

    var waypoints = [];
    if (item.waypoints.length) {
      for (var i = 0; i < item.waypoints.length; i++) {
        var waypoint = item.waypoints[i];

        var locationLat = parseFloat(waypoint.location.lat);
        var locationLng = parseFloat(waypoint.location.lng);

        waypoints.push({
          location: new google.maps.LatLng(locationLat, locationLng),
          stopover: waypoint.stop_on_route,
        });
      }
    }

    var selectedMode = 'DRIVING';
    directionsService.route(
      {
        origin: origin,
        destination: destination,
        waypoints: waypoints,
        optimizeWaypoints: true,

        // Note that Javascript allows us to access the constant
        // using square brackets and a string value as its
        // "property."
        travelMode: google.maps.TravelMode[selectedMode],
      },
      function (response, status) {
        if (status === 'OK') {
          directionsDisplay.setDirections(response);
        } else {
          window.alert('Directions request failed due to ' + status);
        }
      }
    );
  }
}
